import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import axios from 'axios'

const get = axios.get
const post = axios.post
const api = '/api/user/'

const handleRequest = async (request: Promise<any>, thunkAPI: any) => {
  try {
    const res = await request
    return res.data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response.data)
  }
}

export const getUsers = createAsyncThunk('users', (params: {}, thunkAPI) =>
  handleRequest(get(`${api}list`, params), thunkAPI)
)

export const createUser = createAsyncThunk('add-user', (data: {}, thunkAPI) =>
  handleRequest(post(`${api}store`, data), thunkAPI)
)

export const getUserById = createAsyncThunk('user-edit', (id: string, thunkAPI) =>
  handleRequest(get(`${api}edit/${id}`), thunkAPI)
)

export const updateUser = createAsyncThunk('udpate-user', (data: {}, thunkAPI) =>
  handleRequest(post(`${api}update`, data), thunkAPI)
)

export const deleteUser = createAsyncThunk('user-delete', (id: string, thunkAPI) =>
  handleRequest(post(`${api}destroy/${id}`), thunkAPI)
)

export const updateUserPassword = createAsyncThunk('udpate-user-pwd', (data: {}, thunkAPI) =>
  handleRequest(post(`${api}change-password`, data), thunkAPI)
)

export const GetLecturerUsers = createAsyncThunk('lec-users', (params: {}, thunkAPI) =>
  handleRequest(get(`${api}lecturer-list`, params), thunkAPI)
)

export const GetStduentUsers = createAsyncThunk('std-users', (params: {}, thunkAPI) =>
  handleRequest(get(`${api}student-users-list`, params), thunkAPI)
)

export const SetUserLanguage = createAsyncThunk('set-lang', (id: string, thunkAPI) =>
  handleRequest(get(`${api}set-lang/${id}`), thunkAPI)
)

export const SetCampus = createAsyncThunk('udpate-user-campus', (data: {}, thunkAPI) =>
  handleRequest(post('/api/select-campus', data), thunkAPI)
)

export const GetCampuses = createAsyncThunk('campuses', (_, thunkAPI) =>
  handleRequest(get('/api/get-campuses'), thunkAPI)
)

// User Types
type UserState = {
  users: any
  user: any
  total_users: any
  total_roles: any
  total_permission: any
  errors: any
}

const initialState: UserState = {
  users: {
    data: [],
  },
  user: {},
  total_users: '',
  total_roles: '',
  total_permission: '',
  errors: '',
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getUsers.fulfilled, (state, action: PayloadAction<any>) => {
      state.users = action.payload
    })
  },
})

export const {reset} = userSlice.actions
export default userSlice.reducer
